import { Button, ConfigProvider } from 'antd';
import { Component, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, Link } from "react-router-dom";
import './App.scss';
import SensecapeFlow from './pages/canvas-view/canvas-flow';
import BaselineFlow from './pages/baseline-flow/baseline-flow';
import { ReactFlowProvider } from 'reactflow';
import PrepareFlow from './pages/prestudy-flow/prestudy-flow';
import UserStudy, { StudyGroup } from './user-study/user-study';
import { FlowType, TaskValue } from './user-study/task-by-group';
import ApiKeyModal, { getStoredApiKey } from './components/ApiKeyModal';


class Highlight extends HTMLElement {
  constructor() {
    const curr = super();
  }
    handleMouseEnter() {
  }
}

customElements.define("highlight-text", Highlight);

export interface FlowProps {
  task: number;
}

const AppContent = () => {
  const [modalOpen, setModalOpen] = useState(!getStoredApiKey());

  return (
    <div className='App'>
      <ApiKeyModal open={modalOpen} onSave={() => setModalOpen(false)} onClose={() => setModalOpen(false)} />
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#3facff',
          },
        }}
      >
        <ReactFlowProvider>
          <BrowserRouter>
          <Routes>
                <Route path='/' element={<SensecapeFlow task={TaskValue.Empty} />} />

                <Route path='/study' element={<Landing />} />

                <Route path='a' element={<UserStudy group={StudyGroup.A} />} />
                <Route path='b' element={<UserStudy group={StudyGroup.B} />} />
                <Route path='c' element={<UserStudy group={StudyGroup.C} />} />
                <Route path='d' element={<UserStudy group={StudyGroup.D} />} />

                <Route path={FlowType.PrepareAIFutureWork} element={<PrepareFlow task={TaskValue.AIFutureWork} />} />
                <Route path={FlowType.BaselineAIFutureWork} element={<BaselineFlow task={TaskValue.AIFutureWork} />} />
                <Route path={FlowType.SensecapeAIFutureWork} element={<SensecapeFlow task={TaskValue.AIFutureWork} />} />
                <Route path={FlowType.PrepareGlobalWarming} element={<PrepareFlow task={TaskValue.GlobalWarming} />} />
                <Route path={FlowType.BaselineGlobalWarming} element={<BaselineFlow task={TaskValue.GlobalWarming} />} />
                <Route path={FlowType.SensecapeGlobalWarming} element={<SensecapeFlow task={TaskValue.GlobalWarming} />} />

                <Route path={FlowType.BaselineTutorial} element={<BaselineFlow task={TaskValue.Tutorial} />} />
                <Route path={FlowType.SensecapeTutorial} element={<SensecapeFlow task={TaskValue.Tutorial} />} />
                {/* For easy access during dev */}
                <Route path='prep' element={<PrepareFlow task={TaskValue.GlobalWarming} />} />
                <Route path='base' element={<BaselineFlow task={TaskValue.GlobalWarming} />} />
                <Route path='sense' element={<SensecapeFlow task={TaskValue.GlobalWarming} />} />
                <Route path='demo' element={<SensecapeFlow task={TaskValue.Demo} />} />
            </Routes>
          </BrowserRouter>
        </ReactFlowProvider>
      </ConfigProvider>
    </div>
  );
};

export default class App extends Component {
  render() {
    return <AppContent />;
  }
}

const Landing = () => {
  return (
    <div className='landing'>
      <h1>Welcome!</h1>
      <Link to='a'>
        <Button>Group A</Button>
      </Link>
      <Link to='b'>
        <Button>Group B</Button>
      </Link>
      <Link to='c'>
        <Button>Group C</Button>
      </Link>
      <Link to='d'>
        <Button>Group D</Button>
      </Link>
    </div>
  )
}
